var React = require('react');

function Ro (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("path",{"d":"M15.4784 2.62195C14.395 2.22004 13.2234 2 12.0002 2C10.777 1.99996 9.60524 2.22004 8.52192 2.62195L7.65234 12L8.52192 21.378C9.6052 21.78 10.7769 22 12.0002 22C13.2233 22 14.3951 21.78 15.4784 21.378L16.3479 12L15.4784 2.62195Z","fill":"#FFDA44","key":1}),React.createElement("path",{"d":"M22.0003 12C22.0003 7.70041 19.2865 4.03491 15.4785 2.62202V21.3781C19.2865 19.9651 22.0002 16.2997 22.0003 12Z","fill":"#D80027","key":2}),React.createElement("path",{"d":"M2 12C2 16.2997 4.71375 19.9651 8.52168 21.3781L8.52172 2.62205C4.71375 4.03494 2 7.70033 2 12Z","fill":"#0052B4","key":3})]);
}

Ro.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Ro;

Ro.default = Ro;
